"use client";

import Button from "@/common/Button";
import { useAuth } from "@/context/AuthProvider";
import React from "react";

function Banner(props) {
  const { isLoggedIn } = useAuth();

  return (
    <div className="Banner">
      <div className="Banner-wrapper">
        <h4>
          Steigere deine Fahrzeugakquise
          <br />
          und kaufe direkt mit Autoeinfachlos.
        </h4>

        <Button
          maxWidth="328px"
          fontSize="22px"
          paddingHorizontal="32px"
          paddingVertical="16px"
          link={isLoggedIn ? "/marktplatz" : "/registrieren"}
        >
          {isLoggedIn ? "Zum Marktplatz" : "Jetzt Registrieren"}
        </Button>
      </div>
    </div>
  );
}

export default Banner;
